import './RescheduleDrawerLoader.scss';
import 'atoms/loader/Loader.scss';

export default function RescheduleDrawerLoader() {
  return (
    <div className="loader reschedule-drawer-loader">
      <span className="loader title-loader mb-10" />
      <span className="loader subtitle-loader mb-5" />
      <span className="loader subtitle-loader mb-20" />
      <div className="pet-info-loader flex-row mb-12 p-24 border-light-purple radius-24">
        <span className="loader avatar-loader" />
        <div className="flex-column ml-8 w-100">
          <span className="loader pet-name-loader mb-10" />
        </div>
      </div>
      <div className="pet-info-loader flex-row mb-12 p-24 border-light-purple radius-24">
        <span className="loader avatar-loader" />
        <div className="flex-column ml-8 w-100">
          <span className="loader pet-name-loader mb-10" />
          <span className="loader pet-description-loader" />
        </div>
      </div>
      <div className="flex-row mb-15">
        <span className="loader field-loader radius-12 mr-10" />
        <span className="loader field-loader radius-12" />
      </div>
      <span className="loader observation-loader mb-5" />
      <span className="loader observation-loader mb-20" />
      <span className="loader button-loader" />
    </div>
  );
}
